import { NavLink, useLocation } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useState } from "react";
import { routesConfig } from "../routes/routeConfig";
import "../css/layouts/sidebar.css";

export default function Sidebar() {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <button className="menu-toggle" onClick={toggleSidebar}>
                <i className="pi pi-bars"></i>
            </button>

            <aside className={`app-sidebar ${isOpen ? "open" : ""}`}>

                <div className="sidebar-header">
                    <img src="/assets/images/logo/Logo_dark.png" alt="Company Logo" className="sidebar-logo" />
                </div>

                <div className="sidebar-menu">
                    {routesConfig.map((route, index) => {
                        if (route.children) {
                            const isParentActive = route.children.some((child) => location.pathname.startsWith(child.path));
                            return (
                                <Accordion key={index} className="sidebar-accordion" activeIndex={isParentActive ? 0 : null}>
                                    <AccordionTab
                                        header={
                                            <div className={`menu-header ${isParentActive ? "active" : ""}`}>
                                                <i className={`pi ${route.icon}`} />
                                                <span>{route.label}</span>
                                            </div>
                                        }
                                    >
                                        {route.children.map((child, i) => (
                                            <NavLink
                                                key={i}
                                                to={child.path}
                                                className={({ isActive }) => isActive ? "submenu-link active" : "submenu-link"}
                                                onClick={() => setIsOpen(false)}
                                            >
                                                {child.label}
                                            </NavLink>
                                        ))}
                                    </AccordionTab>
                                </Accordion>
                            );
                        }
                        return (
                            <NavLink
                                key={index}
                                to={route.path}
                                className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link" }
                                onClick={() => setIsOpen(false)}
                            >
                                <i className={`pi ${route.icon}`} />
                                <span>{route.label}</span>
                            </NavLink>
                        );
                    })}
                </div>
            </aside>

        </>
    );
}